import { c as _c } from "react/compiler-runtime";
import { postHostedUserConsent } from '@onefootprint/fetch-hosted';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useRequestErrorToast from '@/idv2/hooks/use-request-error-toast';
import type { DeviceInfo } from '@/idv2/utils/get-device';
import { isMobileKind } from '../../../utils/capture';
import ConsentView from './consent-view';
type ConsentProps = {
  authToken: string;
  device: DeviceInfo;
  onConsentSubmit: () => void;
  onNavigatedToPrev: () => void;
  tenantLogoUrl?: string;
  tenantName: string;
  tenantPrivacyPolicyUrl?: string;
  variant?: 'document' | 'selfie';
};
const Consent = t0 => {
  const $ = _c(28);
  const {
    authToken,
    device,
    onConsentSubmit,
    onNavigatedToPrev,
    tenantLogoUrl,
    tenantName,
    tenantPrivacyPolicyUrl,
    variant
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.id-doc.pages.consent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const [consentTextOpen, setConsentTextOpen] = useState(false);
  const requestErrorToast = useRequestErrorToast();
  let t2;
  if ($[1] !== authToken || $[2] !== t) {
    t2 = async () => {
      const descriptionWithoutHyperlinks = String(t(_temp)).replace(/<\/?privacy>|<\/?toc>|<\/?incode_privacy>|<\/?incodePrivacy>|<br\/>/g, "");
      const consentLanguages = [t(_temp2), descriptionWithoutHyperlinks];
      consentLanguages.push(t(_temp3));
      consentLanguages.push(t(_temp4));
      const consentLanguageText = consentLanguages.join(". ");
      await postHostedUserConsent({
        body: {
          consentLanguageText,
          mlConsent: false
        },
        headers: {
          "X-Fp-Authorization": authToken
        }
      });
    };
    $[1] = authToken;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const submitConsent = t2;
  let t3;
  if ($[4] !== requestErrorToast) {
    t3 = error => {
      requestErrorToast(error);
    };
    $[4] = requestErrorToast;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onConsentSubmit) {
    t4 = () => {
      onConsentSubmit();
    };
    $[6] = onConsentSubmit;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== submitConsent || $[9] !== t3 || $[10] !== t4) {
    t5 = {
      mutationFn: submitConsent,
      onError: t3,
      onSuccess: t4
    };
    $[8] = submitConsent;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const consentMutation = useMutation(t5);
  let t6;
  if ($[12] !== device.type) {
    t6 = isMobileKind(device.type);
    $[12] = device.type;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== consentMutation) {
    t7 = () => consentMutation.mutate();
    $[14] = consentMutation;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setConsentTextOpen(true);
    t9 = () => setConsentTextOpen(false);
    $[16] = t8;
    $[17] = t9;
  } else {
    t8 = $[16];
    t9 = $[17];
  }
  let t10;
  if ($[18] !== consentMutation.isPending || $[19] !== consentTextOpen || $[20] !== onNavigatedToPrev || $[21] !== t6 || $[22] !== t7 || $[23] !== tenantLogoUrl || $[24] !== tenantName || $[25] !== tenantPrivacyPolicyUrl || $[26] !== variant) {
    t10 = <ConsentView variant={variant} isMobileDevice={t6} tenantLogoUrl={tenantLogoUrl} tenantName={tenantName} tenantPrivacyPolicyUrl={tenantPrivacyPolicyUrl} isLoading={consentMutation.isPending} consentTextOpen={consentTextOpen} onAgree={t7} onNavigatedToPrev={onNavigatedToPrev} onOpenConsentText={t8} onCloseConsentText={t9} />;
    $[18] = consentMutation.isPending;
    $[19] = consentTextOpen;
    $[20] = onNavigatedToPrev;
    $[21] = t6;
    $[22] = t7;
    $[23] = tenantLogoUrl;
    $[24] = tenantName;
    $[25] = tenantPrivacyPolicyUrl;
    $[26] = variant;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};
export default Consent;
function _temp($) {
  return $["consent-text"].description;
}
function _temp2($_0) {
  return $_0["consent-text"].subtitle;
}
function _temp3($_1) {
  return $_1["consent-text"]["third-party-consent"];
}
function _temp4($_2) {
  return $_2["consent-text"].cta;
}